var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
export var BorderAlignment;
(function (BorderAlignment) {
    BorderAlignment[BorderAlignment["Inner"] = 0] = "Inner";
    BorderAlignment[BorderAlignment["Middle"] = 0.5] = "Middle";
    BorderAlignment[BorderAlignment["Outer"] = 1] = "Outer";
})(BorderAlignment || (BorderAlignment = {}));
var defaultOptions = {
    area: 0,
    borderAlignment: BorderAlignment.Outer,
    borderAlpha: 1,
    borderWidth: 1,
    fillAlpha: 1,
    points: [],
};
var UtilDraw = /** @class */ (function () {
    function UtilDraw() {
        var _this = this;
        this.drawShape = function (graphic, options) {
            var o = __assign({}, defaultOptions, options);
            // Pixi doesn't render border correctly at all times.
            // We need to flip borderAlignment if points don't go clockwise
            // https://github.com/pixijs/pixi.js/issues/5064
            if (o.area >= 0) {
                o.borderAlignment = _this.flipBorderAlignment(o.borderAlignment);
            }
            if (o.fillColor != undefined) {
                graphic.beginFill(o.fillColor, o.fillAlpha);
            }
            if (o.borderColor != undefined) {
                graphic.lineStyle(o.borderWidth, o.borderColor, o.borderAlpha, o.borderAlignment);
            }
            _this.iterateOnPoints(graphic, o.points);
            if (o.fillColor != undefined) {
                graphic.endFill();
            }
            return graphic;
        };
        this.iterateOnPoints = function (target, points) {
            if (points.length <= 0) {
                return target;
            }
            points.forEach(function (p, idx) {
                if (idx === 0) {
                    target.moveTo(p[0], p[1]);
                }
                else {
                    target.lineTo(p[0], p[1]);
                }
            });
            // Last line to finish the shape
            target.lineTo(points[0][0], points[0][1]);
            return target;
        };
        this.flipBorderAlignment = function (alignment) {
            switch (alignment) {
                case BorderAlignment.Inner:
                    return BorderAlignment.Outer;
                case BorderAlignment.Outer:
                    return BorderAlignment.Inner;
                case BorderAlignment.Middle:
                    return BorderAlignment.Middle;
            }
            return -alignment;
        };
    }
    return UtilDraw;
}());
export var utilDraw = new UtilDraw();



//////////////////
// WEBPACK FOOTER
// ./src/utils/graphics/utilDraw.ts
// module id = 860
// module chunks = 3